<section class="sh-dialog__content -sh-overflow-scrolling">
    @if (loading$ | async) {
        <sh-notification [message]="'ui.loading' | translate"></sh-notification>
    }

    @if (processingProgress$ | async; as processingProgress) {
        @if (processingProgress.steps.length > 0) {
            <sh-processing-progress [processingProgress]="processingProgress"></sh-processing-progress>
        } @else {
            <sh-notification [type]="notificationType.Error" [message]="'processing-progress-dialog.messages.no-jobs-found' | translate"></sh-notification>
        }
    }
</section>
